var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "ticket-access-form",
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c(
            "v-stepper",
            {
              attrs: { vertical: "", "non-linear": "" },
              model: {
                value: _vm.currentStep,
                callback: function($$v) {
                  _vm.currentStep = $$v
                },
                expression: "currentStep"
              }
            },
            [
              _c(
                "v-stepper-step",
                {
                  class: {
                    "current-step": _vm.currentStep == 1,
                    "next-step": _vm.highestStepReached < 1,
                    "previous-step": _vm.highestStepReached > 1
                  },
                  attrs: {
                    "edit-icon": "mdi-ticket-confirmation-outline",
                    "complete-icon": "mdi-ticket-confirmation-outline",
                    complete: "",
                    editable: _vm.highestStepReached >= 1,
                    step: "1"
                  }
                },
                [
                  _vm._v(" Información general "),
                  _c("small", [
                    _vm._v(
                      " En esta sección podrás seleccionar los motivos y razones de acceso, lugar de destino y fechas de acceso. "
                    )
                  ])
                ]
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: "1" } },
                [
                  _c("Ticket-Access-Step-One", {
                    ref: "Step1",
                    attrs: { formValues: _vm.formValues.generalInformation },
                    on: {
                      nextStep: _vm.nextStep,
                      previousStep: _vm.previousStep,
                      accessMotives: _vm.enableHardwareStep
                    }
                  })
                ],
                1
              ),
              _c(
                "v-stepper-step",
                {
                  class: {
                    "current-step": _vm.currentStep == 2,
                    "next-step": _vm.highestStepReached < 2,
                    "previous-step": _vm.highestStepReached > 2
                  },
                  attrs: {
                    "edit-icon": "mdi-account-plus",
                    "complete-icon": "mdi-account-plus",
                    complete: "",
                    editable: _vm.highestStepReached >= 2,
                    step: "2"
                  }
                },
                [
                  _vm._v(" Personas involucradas "),
                  _c("small", [
                    _vm._v(
                      ' Son las personas autorizadas, responsables e involucradas en las actividades a realizar en la Sala de Datos. Seleccione cada responsable de la lista de contactos. Para agregar más personas, pulse el botón "Agregar Persona - Empleado de la Empresa" '
                    )
                  ])
                ]
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: "2" } },
                [
                  _c("Ticket-Access-Step-Two", {
                    ref: "Step2",
                    on: {
                      nextStep: _vm.nextStep,
                      previousStep: _vm.previousStep
                    }
                  })
                ],
                1
              ),
              _c(
                "v-stepper-step",
                {
                  class: {
                    "current-step": _vm.currentStep == 3,
                    "next-step": _vm.highestStepReached < 3,
                    "previous-step": _vm.highestStepReached > 3
                  },
                  attrs: {
                    "edit-icon": "mdi-car-multiple",
                    "complete-icon": "mdi-car-multiple",
                    complete: "",
                    editable: _vm.highestStepReached >= 3,
                    step: "3"
                  }
                },
                [
                  _vm._v(" Vehículos de acceso "),
                  _c("small", [_vm._v(" Vehículos de acceso a la sede ")])
                ]
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: "3" } },
                [
                  _c("Ticket-Access-Step-Three", {
                    ref: "Step3",
                    on: {
                      nextStep: _vm.nextStep,
                      previousStep: _vm.previousStep
                    }
                  })
                ],
                1
              ),
              _c(
                "v-stepper-step",
                {
                  class: {
                    "current-step": _vm.currentStep == 4,
                    "next-step": _vm.highestStepReached < 4,
                    "previous-step": _vm.highestStepReached > 4
                  },
                  attrs: {
                    "edit-icon": "mdi-playlist-edit",
                    "complete-icon": "mdi-playlist-edit",
                    complete: "",
                    editable: _vm.highestStepReached >= 4,
                    step: "4"
                  }
                },
                [
                  _vm._v(" Tareas a ejecutar "),
                  _c("small", [
                    _vm._v(
                      " Tareas a ejecutar por parte del cliente o por Daycohost en el Centro de Datos "
                    )
                  ])
                ]
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: "4" } },
                [
                  _c("Ticket-Access-Step-Four", {
                    ref: "Step4",
                    attrs: { formValues: _vm.formValues.tasks },
                    on: {
                      nextStep: _vm.nextStep,
                      previousStep: _vm.previousStep
                    }
                  })
                ],
                1
              ),
              _vm.requiresHardware
                ? _c(
                    "v-stepper-step",
                    {
                      class: {
                        "current-step": _vm.currentStep == 5,
                        "next-step": _vm.highestStepReached < 5,
                        "previous-step": _vm.highestStepReached > 5
                      },
                      attrs: {
                        "edit-icon": "mdi-server",
                        "complete-icon": "mdi-server",
                        complete: "",
                        editable: _vm.highestStepReached >= 5,
                        step: "5"
                      }
                    },
                    [
                      _vm._v(" Administración de equipos "),
                      _c("small", [
                        _vm._v(
                          " Ingreso, egreso e instalación de equipos colocados en el Centro de Datos "
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.requiresHardware
                ? _c(
                    "v-stepper-content",
                    { attrs: { step: "5" } },
                    [
                      _c("Ticket-Access-Step-Five", {
                        ref: "Step5",
                        attrs: { formValues: _vm.formValues.hardwareTransfer },
                        on: {
                          nextStep: _vm.nextStep,
                          previousStep: _vm.previousStep
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-stepper-step",
                {
                  class: {
                    "current-step": _vm.currentStep == 6,
                    "next-step": _vm.highestStepReached < 6,
                    "previous-step": _vm.highestStepReached > 6
                  },
                  attrs: {
                    "edit-icon": "mdi-check-all",
                    "complete-icon": "mdi-check-all",
                    complete: "",
                    editable: _vm.highestStepReached >= 6,
                    step: "6"
                  }
                },
                [
                  _vm._v(" Resumen del ticket de Acceso "),
                  _c("small", [
                    _vm._v(
                      " Resumen de toda la información suministrada hasta ahora "
                    )
                  ])
                ]
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: "6" } },
                [
                  _c("Ticket-Access-Step-Six", {
                    ref: "Step6",
                    attrs: {
                      formValues: _vm.formValues.generalInformation,
                      accessTicket: _vm.accessTicket,
                      requiresHardware: _vm.requiresHardware
                    },
                    on: {
                      nextStep: _vm.nextStep,
                      previousStep: _vm.previousStep,
                      reset: function($event) {
                        return _vm.$router.push({ name: "tickets" })
                      },
                      sendAccessTicket: _vm.sendAccessTicket
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", color: "error" },
          model: {
            value: _vm.errorLoadingContent,
            callback: function($$v) {
              _vm.errorLoadingContent = $$v
            },
            expression: "errorLoadingContent"
          }
        },
        [
          _vm._v(
            " Ocurrió un error obteniendo la información para la creación del ticket, por favor intente nuevamente "
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  _vm.errorLoadingContent = false
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }